
import { Course } from '../types';
import { children_act } from './children_act';
import { legal_standards } from './legal_standards';
import { miam_mediation } from './miam_mediation';
import { urgent_hearings } from './urgent_hearings';
import { non_molestation } from './non_molestation';
import { harassment_boundaries } from './harassment_boundaries';
import { position_statements } from './position_statements';
import { witness_statements } from './witness_statements';
import { fhdra_basics } from './fhdra_basics';
import { representing_yourself } from './representing_yourself';
import { fact_finding } from './fact_finding';
import { final_hearing } from './final_hearing';
import { cafcass } from './cafcass';
import { enforcement } from './enforcement';
import { parallel_parenting } from './parallel_parenting';
import { alienating_behaviours } from './alienating_behaviours';
import { direct_access } from './direct_access';
import { co_parenting_skills } from './co_parenting_skills';
import { emotional_regulation } from './emotional_regulation';
import { positive_parenting } from './positive_parenting';
import { grandparents } from './grandparents';
import { child_maintenance } from './child_maintenance';
import { schedule_1 } from './schedule_1';
import { digital_bundle } from './digital_bundle';
import { c100_application } from './c100_application';
import { disclosure_discovery } from './disclosure_discovery';
import { dra_tactics } from './dra_tactics';
import { challenging_s7 } from './challenging_s7';
import { mindset_shift } from './mindset_shift';
import { false_allegations } from './false_allegations';
import { family_stability_blueprint } from './family_stability_blueprint';
import { dadfoundry_blueprint } from './dadfoundry_blueprint';
import { newborn_operations_manual } from './newborn_operations_manual';
import { the_fatherhood_blueprint } from './the_fatherhood_blueprint';

export const COURSES: Course[] = [
  // The Foundation
  mindset_shift,
  the_fatherhood_blueprint,
  family_stability_blueprint,
  dadfoundry_blueprint,

  // Step 1: Starting the Process
  children_act,
  miam_mediation,
  c100_application,
  representing_yourself,
  direct_access,
  
  // Step 2: Preparing Your Evidence
  legal_standards,
  disclosure_discovery,
  position_statements,
  witness_statements,
  digital_bundle,
  cafcass,

  // Step 3: The Courtroom Path
  urgent_hearings,
  fhdra_basics,
  fact_finding,
  dra_tactics,
  final_hearing,

  // Step 4: Managing Complex Issues
  enforcement,
  challenging_s7,
  false_allegations,
  non_molestation,
  harassment_boundaries,
  alienating_behaviours,

  // Step 5: Parenting & Wellbeing
  co_parenting_skills,
  parallel_parenting,
  positive_parenting,
  emotional_regulation,
  newborn_operations_manual,

  // Step 6: Finances & Support
  child_maintenance,
  schedule_1,
  grandparents
];
